import React from 'react';
interface LogoProps {
  variant?: 'full' | 'icon';
  size?: 'sm' | 'md' | 'lg';
}
export function Logo({
  variant = 'full',
  size = 'md'
}: LogoProps) {
  const sizeClasses = {
    sm: 'h-8',
    md: 'h-12',
    lg: 'h-20'
  };
  if (variant === 'icon') {
    return <img src="https://uploadthingy.s3.us-west-1.amazonaws.com/1gKnRjTmGvkH4gFp5JE9UP/pasted-image.png" alt="AllHere" className={`${sizeClasses[size]} w-auto`} data-id="element-365" />;
  }
  return <img src="https://uploadthingy.s3.us-west-1.amazonaws.com/h8n9HuaWS8aGb9xAdET8aH/pasted-image.png" alt="AllHere" className={`${sizeClasses[size]} w-auto`} data-id="element-366" />;
}